import styled from 'styled-components';

export const WrapperSlider = styled.div`
  position: relative;
  margin-top: ${({ theme }) => theme.spacing.km3};

  > fuel-typography {
    position: absolute;
    right: 0;
  }
`;
